import { render, staticRenderFns } from "./AtlasPath.vue?vue&type=template&id=1be62287&scoped=true"
import script from "./AtlasPath.vue?vue&type=script&lang=js"
export * from "./AtlasPath.vue?vue&type=script&lang=js"
import style0 from "./AtlasPath.vue?vue&type=style&index=0&id=1be62287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be62287",
  null
  
)

export default component.exports